<div class="At-SettingsContent">
  <div class="At-helparea">
    <div class="At-headbox">
      <h3>Help Desk</h3>
      <p>Tell us what you are hacing problem with and our customer support will get
        back to you in 24 hrs.</p>
    </div>
    <form class="At-Helpform">
      <div class="form-group">
        <label>Select Topic</label>
        <div class="At-Select">
          <select class="form-control">
            <option>Manage Channels</option>
            <option>Manage Channels</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label>Write Your Message</label>
        <textarea class="form-control"></textarea>
      </div>
      <div class="form-group">
        <button type="button" class="At-Btn">submit</button>
      </div>
    </form>
  </div>
</div>
